<template>
    <div class="c-standard-summary">
        <table class="table">
            <tbody>
            <tr>
                <td class="text-right">
                    <b>{{Core.Definition.getDefinition('Sous-total')}}</b>
                </td>
                <td class="text-right">
                    {{Core.Currency.format(dataSubTotal)}}
                </td>
            </tr>
            <tr v-for="tax in taxes">
                <td class="text-right">
                    <b>{{tax.label}}</b>
                </td>
                <td class="text-right">
                    {{Core.Currency.format(tax.total)}}
                </td>
            </tr>
            <tr>
                <td class="text-right">
                    <b>{{Core.Definition.getDefinition('Total')}}</b>
                </td>
                <td class="text-right">
                    {{Core.Currency.format(dataTotal)}}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import InputCurrency from './InputCurrency'
    export default {
        name: 'Summary',
        components: {
            InputCurrency
        },
        props: {
            id: {
                type: String,
                default: ''
            },
            form: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            value: {
                type: Array,
                default: function () {
                    return []
                }
            },
            taxes: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
            value: {
                handler(val) {
                },
                deep:true
            }
        },
        mounted() {
            this.dataTaxes = this.taxes
        },
        data: () => {
            return {
                Core: window.Core,
                dataSubTotal: 0,
                dataTotal: 0,
                dataTaxes: []
            }
        },
        methods: {
        }
    }
</script>
